import PageName  from '@/views/backstage/constants/PageName'
import Routes from '@/constants/predefined_routes.js'

let make_breadcrumbs = (prefix, paths) => {
  paths.unshift({path: '/', name: PageName.PAGE_HOME})
  for (let item of paths) {
    item['path'] = prefix + item['path']
  }
  return paths
}

let file_type_to_name = (type) => {
  switch(type) {
    case 'recordgroup': return PageName.PAGE_RECORDGROUP_MANAGEMENT
    case 'sub_recordgroup': return PageName.PAGE_SUB_RECORDGROUP_MANAGEMENT
    case 'folder': return PageName.PAGE_FOLDER_MANAGEMENT
    default: return '未知的檔案類型'
  }
}

export default [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/frontstage/Index.vue'),
    children: [
      {
        path: '',
        name: 'root',
        component: () => import('@/views/frontstage/Home.vue'),
      },
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/frontstage/Home.vue'),
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/frontstage/News.vue'),
      },
      {
        path: 'themes',
        name: 'themes',
        component: () => import('@/views/frontstage/Themes.vue'),
      },
      {
        path: 'news/detail/:id',
        name: 'newsdetail',
        component: () => import('@/views/frontstage/NewsDetail.vue'),
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('@/views/frontstage/About.vue'),
      },
      {
        path: 'faq',
        name: 'faq',
        component: () => import('@/views/frontstage/FAQ.vue'),
      },
      {
        path: 'sitemap',
        name: 'sitemap',
        component: () => import('@/views/frontstage/Sitemap.vue'),
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/frontstage/Contact.vue'),
      },
      {
        path: 'collection',
        name: 'collection',
        component: () => import('@/views/frontstage/Collection.vue'),
      },
      {
        path: 'article/:id',
        name: 'article',
        component: () => import('@/views/frontstage/Article.vue'),
      },
      {
        path: 'recommended',
        name: 'recommended',
        component: () => import('@/views/frontstage/RecommendedList.vue'),
      },
      {
        path: 'related-link',
        name: 'related-links',
        component: () => import('@/views/frontstage/Home.vue'),
      },
      {
        path: 'related-link/:link',
        name: 'related-link',
        component: () => import('@/views/frontstage/home/related_links/RelatedLinkDetail.vue'),
      },
      {
        path: 'security',
        name: 'security',
        component: () => import('@/views/frontstage/footer/FooterSecurityPage.vue'),
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import('@/views/frontstage/footer/FooterPrivacyPage.vue'),
      },
      {
        path: 'opendata',
        name: 'opendata',
        component: () => import('@/views/frontstage/footer/FooterOpenDataPage.vue'),
      },
      {
        path: 'contactus',
        name: 'contactus',
        component: () => import('@/views/frontstage/footer/FooterContactUsPage.vue'),
      },
    ]
  },  
  {
    path: '/backstage/login',
    name: 'login',
    component: () => import('@/views/backstage/login/Login.vue'),
  },
  {
    path: '/backstage/reset',
    name: 'reset',
    component: () => import('@/views/backstage/login/LoginReset.vue'),
  },
  {
    path: '/backstage',
    name: 'index',
    component: () => import('@/views/backstage/Index.vue'),
    children: [
      // 首頁
      {
        path: '',
        component: () => import('@/views/backstage/pages/DashboardPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [])
        }
      },
      {
        path: Routes.backstage.DASHBOARD,
        component: () => import('@/views/backstage/pages/DashboardPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.DASHBOARD}`,
              name: PageName.PAGE_DASHBOARD
            }
          ])
        }
      },
      // 整合查巡
      {
        path: Routes.backstage.INTEGREATED_SERACH,
        component: () => import('@/views/backstage/pages/IntegratedSearchPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.INTEGREATED_SERACH}`,
              name: PageName.PAGE_INTEGREATED_SERACH
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.INTEGREATED_SERACH}/:type/view/:id`,
        component: () => import('@/views/backstage/pages/DetailPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.INTEGREATED_SERACH}`,
              name: PageName.PAGE_INTEGREATED_SERACH
            },
            {
              path: `/${Routes.backstage.INTEGREATED_SERACH}/${params.type}/view/${params.id}`,
              name: '...'
            },
          ])
        }
      },
      // 數位資源管理
      {
        path: Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT,
        component: () => import('@/views/backstage/pages/DigitalResourceManagementPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT}`,
              name: PageName.PAGE_DIGITAL_RESOURCE_MANAGEMENT
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT}/:type/view/:id`,
        component: () => import('@/views/backstage/pages/DetailPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT}`,
              name: PageName.PAGE_DIGITAL_RESOURCE_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT}/${params.type}/view/${params.id}`,
              name: '...'
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT}/:type/edit/:id`,
        component: () => import('@/views/backstage/pages/EditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT}`,
              name: PageName.PAGE_DIGITAL_RESOURCE_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT}/${params.type}/edit/${params.id}`,
              name: '...'
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT}/:type/add`,
        component: () => import('@/views/backstage/pages/EditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT}`,
              name: PageName.PAGE_DIGITAL_RESOURCE_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.DIGITAL_RESOURCE_MANAGEMENT}/${params.type}/add`,
              name: '登錄資料'
            }
          ])
        }
      },
      // 審核專區
      {
        path: Routes.backstage.REVIEW_MANAGEMENT,
        component: () => import('@/views/backstage/pages/review_management/ReviewManagementPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.REVIEW_MANAGEMENT}`,
              name: PageName.PAGE_REVIEW
            },
          ])
        }
      },
      {
        path: Routes.backstage.FRONT_STAGE_DATA_PUBLISH,
        component: () => import('@/views/backstage/pages/review_management/FrontStageDataPublishPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.FRONT_STAGE_DATA_PUBLISH}`,
              name: PageName.PAGE_FRONT_STAGE_DATA
            },
          ])
        }
      },
      {
        path: `${Routes.backstage.FRONT_STAGE_DATA_PUBLISH}/:type/view/:id`,
        component: () => import('@/views/backstage/pages/review_management/FrontStageDetailPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.FRONT_STAGE_DATA_PUBLISH}`,
              name: PageName.PAGE_FRONT_STAGE_DATA
            },
            {
              path: `/${Routes.backstage.FRONT_STAGE_DATA_PUBLISH}/view/${params.id}`,
              name: '...'
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.REVIEW_MANAGEMENT}/:type/view/:id`,
        component: () => import('@/views/backstage/pages/review_management/ReviewDetailPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.REVIEW_MANAGEMENT}`,
              name: PageName.PAGE_REVIEW
            },
            {
              path: `/${Routes.backstage.REVIEW_MANAGEMENT}/${params.type}/view/${params.id}`,
              name: '...'
            }
          ])
        }
      },
      // 檔案類別管理
      {
        path: Routes.backstage.RECORDGROUP_MANAGEMENT,
        component: () => import('@/views/backstage/pages/organization_management/RecordGroupManagementPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.RECORDGROUP_MANAGEMENT}`,
              name: PageName.PAGE_RECORDGROUP_MANAGEMENT
            }
          ])
        }
      },
      {
        path: Routes.backstage.SUB_RECORDGROUP_MANAGEMENT,
        component: () => import('@/views/backstage/pages/organization_management/SubRecordGroupManagementPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.SUB_RECORDGROUP_MANAGEMENT}`,
              name: PageName.PAGE_SUB_RECORDGROUP_MANAGEMENT
            }
          ])
        }
      },
      {
        path: Routes.backstage.FOLDER_MANAGEMENT,
        component: () => import('@/views/backstage/pages/organization_management/FolderManagementPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.FOLDER_MANAGEMENT}`,
              name: PageName.PAGE_FOLDER_MANAGEMENT
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.ORGANIZATION}/:type/view/:id`,
        component: () => import('@/views/backstage/pages/organization_management/OrganizationDetailPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.ORGANIZATION}/${params.type}`,
              name: file_type_to_name(params.type)
            },
            {
              path: `/${Routes.backstage.ORGANIZATION}/${params.type}/view/${params.id}`,
              name: '...'
            },
          ])
        }
      },
      {
        path: `${Routes.backstage.ORGANIZATION}/:type/edit/:id`,
        component: () => import('@/views/backstage/pages/organization_management/OrganizationEditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.ORGANIZATION}/${params.type}`,
              name: file_type_to_name(params.type)
            },
            {
              path: `/${Routes.backstage.ORGANIZATION}/${params.type}/edit/${params.id}`,
              name: '...'
            },
          ])
        }
      },
      {
        path: `${Routes.backstage.ORGANIZATION}/:type/add`,
        component: () => import('@/views/backstage/pages/organization_management/OrganizationEditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.ORGANIZATION}/${params.type}`,
              name: file_type_to_name(params.type)
            },
            {
              path: `/${Routes.backstage.ORGANIZATION}/${params.type}/edit/${params.id}`,
              name: '...'
            },
          ])
        }
      },
      // 系統管理
      {
        path: Routes.backstage.ACCOUNT_MANAGEMENT,
        component: () => import('@/views/backstage/pages/system_management/account_management/AccountManagementPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.ACCOUNT_MANAGEMENT}`,
              name: PageName.PAGE_ACCOUNT_MANAGEMENT
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.ACCOUNT_MANAGEMENT}/view/:id`,
        component: () => import('@/views/backstage/pages/system_management/account_management/AccountDetailPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.ACCOUNT_MANAGEMENT}`,
              name: PageName.PAGE_ACCOUNT_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.ACCOUNT_MANAGEMENT}/view/${params.id}`,
              name: '...'
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.ACCOUNT_MANAGEMENT}/edit/:id`,
        component: () => import('@/views/backstage/pages/system_management/account_management/AccountEditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.ACCOUNT_MANAGEMENT}`,
              name: PageName.PAGE_ACCOUNT_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.ACCOUNT_MANAGEMENT}/edit/${params.id}`,
              name: '...'
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.ACCOUNT_MANAGEMENT}/add`,
        component: () => import('@/views/backstage/pages/system_management/account_management/AccountEditPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.ACCOUNT_MANAGEMENT}`,
              name: PageName.PAGE_ACCOUNT_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.ACCOUNT_MANAGEMENT}/add`,
              name: '新增使用者'
            }
          ])
        }
      },
      {
        path: Routes.backstage.SYSTEM_LOG,
        component: () => import('@/views/backstage/pages/system_management/system_log/SystemLogPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.SYSTEM_LOG}`,
              name: PageName.PAGE_SYSTEM_LOG
            },
          ])
        }
      },
      // 問題回報管理列表
      {
        path: Routes.backstage.ISSUE_REPORT_MANAGEMENT,
        component: () => import('@/views/backstage/pages/system_management/IssueReportPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.ISSUE_REPORT_MANAGEMENT}`,
              name: PageName.PAGE_ISSUE_REPORT_MANAGEMENT
            },
          ])
        }
      },
      {
        path: `${Routes.backstage.ISSUE_REPORT_MANAGEMENT}/edit/:id`,
        component: () => import('@/views/backstage/pages/system_management/IssueReportDetailPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.ISSUE_REPORT_MANAGEMENT}`,
              name: PageName.PAGE_ISSUE_REPORT_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.ISSUE_REPORT_MANAGEMENT}/edit/${params.id}`,
              name: '...'
            },
          ])
        }
      },
      {
        path: Routes.backstage.SYNONYM_MANAGEMENT,
        component: () => import('@/views/backstage/pages/system_management/synonym_management/SynonymManagementPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.SYNONYM_MANAGEMENT}`,
              name: PageName.PAGE_SYNONYM_MANAGEMENT
            },
          ])
        }
      },
      // 我的問題回報
      {
        path: Routes.backstage.MY_ISSUE_REPORT,
        component: () => import('@/views/backstage/pages/my_issue_report/MyIssueReportPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.MY_ISSUE_REPORT}`,
              name: PageName.PAGE_MY_ISSUE_REPORT
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.MY_ISSUE_REPORT}/view/:id`,
        component: () => import('@/views/backstage/pages/my_issue_report/MyIssueReportDetailPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.MY_ISSUE_REPORT}`,
              name: PageName.PAGE_MY_ISSUE_REPORT
            },
            {
              path: `/${Routes.backstage.MY_ISSUE_REPORT}/view/${params.id}`,
              name: '...'
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.MY_ISSUE_REPORT}/edit/:id`,
        component: () => import('@/views/backstage/pages/my_issue_report/MyIssueReportEditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.MY_ISSUE_REPORT}`,
              name: PageName.PAGE_MY_ISSUE_REPORT
            },
            {
              path: `/${Routes.backstage.MY_ISSUE_REPORT}/edit/${params.id}`,
              name: '...'
            }
          ])
        }
      },
      // 網站(前臺)管理
      {
        path: Routes.backstage.FRONT_STAGE_MANAGEMENT,
        component: () => import('@/views/backstage/pages/frontstage_management/theme_management/ThemeMagagement.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.THEME_MANAGEMENT}`,
              name: PageName.PAGE_THEME_MANAGEMENT
            },
          ])
        }
      },
      // 主題專區管理
      {
        path: Routes.backstage.THEME_MANAGEMENT,
        component: () => import('@/views/backstage/pages/frontstage_management/theme_management/ThemeMagagement.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.THEME_MANAGEMENT}`,
              name: PageName.PAGE_THEME_MANAGEMENT
            },
          ])
        }
      },
      {
        path: `${Routes.backstage.THEME_MANAGEMENT}/theme/edit/:theme_id`,
        component: () => import('@/views/backstage/pages/frontstage_management/theme_management/ThemeEditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.THEME_MANAGEMENT}`,
              name: PageName.PAGE_THEME_MANAGEMENT
            },
            {
              //http://192.168.2.60:8082/backstage/front-stage-management/theme-management/theme/edit/123
              path: `/${Routes.backstage.THEME_MANAGEMENT}/theme/edit/${params.theme_id}`,
              name: '...'
            },
          ])
        }
      },
      {
        path: `${Routes.backstage.THEME_MANAGEMENT}/theme/add`,
        component: () => import('@/views/backstage/pages/frontstage_management/theme_management/ThemeEditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.THEME_MANAGEMENT}`,
              name: PageName.PAGE_THEME_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.THEME_MANAGEMENT}/theme/add/${params.id}`,
              name: '...'
            },
          ])
        }
      },
      // 最新消息管理
      {
        path: Routes.backstage.LATEST_NEWS_MANAGEMENT,
        component: () => import('@/views/backstage/pages/frontstage_management/latest_news_management/LatestNewsManagementPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.LATEST_NEWS_MANAGEMENT}`,
              name: PageName.PAGE_LATEST_NEWS_MANAGEMENT
            },
          ])
        }
      },
      {
        path: `${Routes.backstage.LATEST_NEWS_MANAGEMENT}/add`,
        component: () => import('@/views/backstage/pages/frontstage_management/latest_news_management/LatestNewsEditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.LATEST_NEWS_MANAGEMENT}`,
              name: PageName.PAGE_LATEST_NEWS_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.LATEST_NEWS_MANAGEMENT}/add`,
              name: '新增最新消息'
            },
          ])
        }
      },
      {
        path: `${Routes.backstage.LATEST_NEWS_MANAGEMENT}/edit/:id`,
        component: () => import('@/views/backstage/pages/frontstage_management/latest_news_management/LatestNewsEditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.LATEST_NEWS_MANAGEMENT}`,
              name: PageName.PAGE_LATEST_NEWS_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.LATEST_NEWS_MANAGEMENT}/edit/${params.id}`,
              name: '編輯最新消息'
            },
          ])
        }
      },
      // 本日精選管理
      {
        path: Routes.backstage.RECOMMENDED_ARTICLE_MANAGEMENT,
        component: () => import('@/views/backstage/pages/frontstage_management/recommended_article_management/RecommendedArticleManagementPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.RECOMMENDED_ARTICLE_MANAGEMENT}`,
              name: PageName.PAGE_RECOMMENDED_ARTICLE_MANAGEMENT
            },
          ])
        }
      },
      // 本日精選資料列表
      {
        path: `${Routes.backstage.RECOMMENDED_ARTICLE_MANAGEMENT}/list/:date`,
        component: () => import('@/views/backstage/pages/frontstage_management/recommended_article_management/RecommendedArticleListPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.RECOMMENDED_ARTICLE_MANAGEMENT}`,
              name: PageName.PAGE_RECOMMENDED_ARTICLE_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.RECOMMENDED_ARTICLE_MANAGEMENT}/list/${params.date}`,
              name: '本日精選資料列表'
            },
          ])
        }
      },
      // 常見問題管理
      {
        path: Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT,
        component: () => import('@/views/backstage/pages/frontstage_management/frequently_asked_question_management/FrequentlyAskedQuestionManagementPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}`,
              name: PageName.PAGE_FREQUENTLY_ASKED_QUESTION_MANAGEMENT
            },
          ])
        }
      },
      {
        path: `${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}/add`,
        component: () => import('@/views/backstage/pages/frontstage_management/frequently_asked_question_management/FrequentlyAskedQuestionEditPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}`,
              name: PageName.PAGE_FREQUENTLY_ASKED_QUESTION_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}/add`,
              name: '新增常見問題'
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}/edit/:id`,
        component: () => import('@/views/backstage/pages/frontstage_management/frequently_asked_question_management/FrequentlyAskedQuestionEditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}`,
              name: PageName.PAGE_FREQUENTLY_ASKED_QUESTION_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}/edit/${params.id}`,
              name: '編輯常見問題'
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}/add`,
        component: () => import('@/views/backstage/pages/frontstage_management/frequently_asked_question_management/FrequentlyAskedQuestionEditPage.vue'),
        meta: {
          breadcrumbs: () => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}`,
              name: PageName.PAGE_FREQUENTLY_ASKED_QUESTION_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}/add`,
              name: '新增常見問題'
            }
          ])
        }
      },
      {
        path: `${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}/edit/:id`,
        component: () => import('@/views/backstage/pages/frontstage_management/frequently_asked_question_management/FrequentlyAskedQuestionEditPage.vue'),
        meta: {
          breadcrumbs: (params) => make_breadcrumbs('/backstage', [
            {
              path: `/${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}`,
              name: PageName.PAGE_FREQUENTLY_ASKED_QUESTION_MANAGEMENT
            },
            {
              path: `/${Routes.backstage.FREQUENTLY_ASKED_QUESTION_MANAGEMENT}/edit/${params.id}`,
              name: '編輯常見問題'
            }
          ])
        }
      },
      // 測試
      {
        path: 'test',
        component: () => import('@/views/backstage/pages/test/TestPage.vue'),
      },
      // 網站產生器
      {
        path: 'site-admin',
        component: () => import('@/views/backstage/pages/site_admin/SiteAdminPage.vue'),
      },
    ]
  }
]
